import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";
import { getCookie } from "../../../helper/utils";

const aiChatApi = {
  getUserSearches: () => {
    const url = `/user-searches`;
    return request({
      method: HTTP_METHOD.GET,
      silent: true,
      url,
    });
  },

  getChats: (payload) => {
    const { Id = "", customQuery = "", textPrompt = "" } = payload;
    const userId = getCookie("user_name");
    //  const url = `/data-on-demand/textToSql?Id=${Id}&customQuery=${customQuery}&textPrompt=${textPrompt}&userId=${userId}`;
    const url = `/jia/fetch`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: {
        prompt: textPrompt,
        ...(!textPrompt ? { id: Id } : {})
      },
    });
  },
  sendFeedback: (payload) => {
    const userId = getCookie("user_name");
    const {
      sqlQuery = "",
      textPrompt = "",
      feedback,
      feedBackGiven,
      feedBackResponse,
    } = payload;
    const url = `/data-on-demand/saveResponse?userId=${userId}&sqlQuery=${sqlQuery}&textPrompt=${textPrompt}&feedback=${feedback}&feedBackGiven=${feedBackGiven}&feedBackResponse=${feedBackResponse}`;
    return request({
      method: HTTP_METHOD.POST,
      url,
    });
  },
  getRealTimeDate: (payload) => {
    const url = `/data-on-demand/recentDate`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  getPopularSearchesList: (payload) => {
    const url = `/jia/popular-searches`;
    return request({
      method: HTTP_METHOD.GET,
      silent: true,
      url,
    });
  },
};

export default aiChatApi;
